import React, { useState } from 'react';
import { FeedbackForSection, ModalPortal } from '..';
import css from './QualificationModal.css';
import {
    HORSE_QUALIFICATION_BASIC_TRAINING,
    HORSE_QUALIFICATION_TOURNAMENT_EXPERIENCE,
    horseQualifications,
} from '../../marketplace-custom-config';
import classNames from 'classnames';
import { FEEDBACK_SECTION_ID_QUALIFICATION } from '../FeedbackForSection/configs';

const horseQualificationsKeys = [
    HORSE_QUALIFICATION_BASIC_TRAINING,
    HORSE_QUALIFICATION_TOURNAMENT_EXPERIENCE,
];

/**
 *
 * @param {Object} props
 * @param {boolean} [props.isOpen]
 * @param {function} [props.onClose]
 * @param {Object} props.currentListing
 * @param {string} [props.initialQualification]
 * @returns
 */
const QualificationModal = ({
    isOpen,
    onClose: onCloseModal,
    currentListing,
    initialQualification,
}) => {
    const [qualificationKey, setQualificationKey] = useState(
        initialQualification || horseQualificationsKeys[0]
    );
    const { userCountry = 'CH' } = currentListing?.attributes?.publicData || {};

    const includedDisciplines =
        horseQualifications[qualificationKey]?.includedDisciplines?.[userCountry];

    const includedDisciplinesFlatted = Object.entries(includedDisciplines).reduce(
        (acc, [discipline, qualifications]) => {
            qualifications.forEach(qualificationItem => {
                acc.push({ [discipline]: qualificationItem });
            });
            return acc;
        },
        []
    );

    return (
        <ModalPortal
            id="QualificationModal"
            contentClassName={css.modalContent}
            isOpen={isOpen}
            onClose={onCloseModal}
            containerClassNameJoined
        >
            <h3 className={css.title}>Qualifikationen</h3>
            <p className={css.description}>
                Erfahre, welche Qualifikationen derzeit bei unserem Matching unterstützt werden.
            </p>
            <nav className={css.nav}>
                {horseQualificationsKeys.map(key => (
                    <div
                        key={`QualificationModal-NavItem-${key}`}
                        onClick={() => setQualificationKey(key)}
                        className={classNames(css.navItem, {
                            [css.selected]: qualificationKey === key,
                        })}
                    >
                        {horseQualifications[key].label}
                    </div>
                ))}
            </nav>
            <section className={css.disciplinesListHolder}>
                {includedDisciplinesFlatted.map((disciplineEntry, index, arr) => {
                    const [discipline, qualification] = Object.entries(disciplineEntry).flatMap(
                        s => s
                    );

                    return (
                        <React.Fragment key={`${discipline}-${qualification}-${index}`}>
                            <div className={css.disciplineItem}>
                                <span>{discipline}</span>
                                <span>{qualification}</span>
                            </div>
                            {Boolean(index < arr.length - 1) && <div className={css.delimiter} />}
                        </React.Fragment>
                    );
                })}
            </section>
            <FeedbackForSection
                sectionId={FEEDBACK_SECTION_ID_QUALIFICATION}
                extraParams={{
                    type: 'qualificationSection',
                }}
            />
        </ModalPortal>
    );
};

export default QualificationModal;
